import loadable from "@loadable/component";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { getKey } from "../../helpers/sessionKey";

const CreateDarazOrderComponent = loadable(
  () => import("../../components/DarazOrder/CreateDarazOrder")
);

const CreateDarazOrder = () => {
  const navigate = useNavigate();
  const { data: profile, isLoading } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["daraz-order"],
    navigateURL: "/",
  });
  const defaultBranch = getKey("default-branch");

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.DARAZ_ORDER}`;
    let formData = {
      ...values,
    };
    console.log(formData);
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status == 201) {
        navigate(`/`);
      }
    } catch (err) {
      console.log(err);
    }
  };
  //   const url = `${APIS.DARAZ_ORDER}`;

  //   // ✅ Filter out empty items before sending to API
  //   const cleanedItems =
  //     values?.items
  //       ?.filter((item: any) => {
  //         // Keep only non-empty items (at least one field filled)
  //         return (
  //           item.description?.trim() ||
  //           item.product_type?.trim() ||
  //           item.piece > 0 ||
  //           item.weight > 0
  //         );
  //       })
  //       ?.map((item: any) => ({
  //         description: item.description?.trim() || "",
  //         product_type: item.product_type?.trim() || "",
  //         piece: item.piece || 0,
  //         weight: item.weight || 0,
  //       })) || [];

  //   // ✅ Build final formData
  //   const formData = {
  //     ...values,
  //     items: cleanedItems.length > 0 ? cleanedItems : [],
  //   };

  //   console.log("Final payload to API:", formData);

  //   try {
  //     const res = await mutateAsync({ url, formData, setError });
  //     if (res.status === 201) {
  //       navigate(`/`);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Daraz Consignment
        </span>
      </div>
      <CreateDarazOrderComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
        defaultBranch={defaultBranch}
      />
    </>
  );
};
export default CreateDarazOrder;
